import type { ReactNode } from 'react';

export interface AdsBlock {
  id: string;
  title: string;
  description: ReactNode;
  buttonText: string;
  bgSmall: string;
  bgLarge: string;
  type: string;
}

export const ADS_BLOCKS = {
  PROSPECT: {
    id: 'prospect-view',
    title: 'Track Source Performance',
    description: (
      <>
        Reveal real-time performance by source and student type with
        <span className="font-bold"> Prospect View</span> to empower smarter
        outreach, better ROI, and stronger enrollment outcomes.
      </>
    ),
    buttonText: 'Talk to us',
    bgSmall: 'prospect-bg-md',
    bgLarge: 'prospect-bg-lg',
    type: 'PROSPECT_VIEW',
  },
  FINANCE: {
    id: 'financial-aid',
    title: 'Understand Your Pricing Power',
    description: (
      <>
        Use <span className="font-bold">Financial Aid View</span> to understand
        your institution's pricing power so you're better positioned to make
        more competitive aid offers to the students you desire.
      </>
    ),
    buttonText: 'Talk to us',
    bgSmall: 'finance-bg-md',
    bgLarge: 'finance-bg-lg',
    type: 'FINANCIAL_AID_VIEW',
  },
  RETENTION: {
    id: 'retention',
    title: 'Reduce Attrition Risk',
    description: (
      <>
        Reach your retention goals by linking demographic data and
        pre-enrollment characteristics on a student level for more productive
        intervention with <span className="font-bold">Retention View</span>.
      </>
    ),
    buttonText: 'Talk to us',
    bgSmall: 'retention-bg-md',
    bgLarge: 'retention-bg-lg',
    type: 'RETENTION_VIEW',
  },
} satisfies Record<string, AdsBlock>;

export type AdsBlockKey = keyof typeof ADS_BLOCKS;
